import { defineMessages } from 'react-intl';

const gandalfFlashbarMessages = defineMessages({
  ariaLabel: {
    id: 'gandalfFlashbar.ariaLabel',
    defaultMessage: 'Notifications',
    description: 'Aria label for the flashbar component',
  },
  notificationBarAriaLabel: {
    id: 'gandalfFlashbar.notificationBarAriaLabel',
    defaultMessage: 'View all notifications',
    description: 'Aria label for the notifications bar',
  },
  notificationBarText: {
    id: 'gandalfFlashbar.notificationBarText',
    defaultMessage: 'Notifications',
    description:
      'Label for the notifications bar, only shows when there are enough notifications to stack (>3)',
  },
  errorIconAriaLabel: {
    id: 'gandalfFlashbar.errorIconAriaLabel',
    defaultMessage: 'Error',
    description: 'Aria Label for the error icon on a notification',
  },
  warningIconAriaLabel: {
    id: 'gandalfFlashbar.warningIconAriaLabel',
    defaultMessage: 'Warning',
    description: 'Aria Label for the warning icon on a notification',
  },
  successIconAriaLabel: {
    id: 'gandalfFlashbar.successIconAriaLabel',
    defaultMessage: 'Success',
    description: 'Aria Label for the success icon on a notification',
  },
  infoIconAriaLabel: {
    id: 'gandalfFlashbar.infoIconAriaLabel',
    defaultMessage: 'Info',
    description: 'Aria Label for the info icon on a notification',
  },
  inProgressIconAriaLabel: {
    id: 'gandalfFlashbar.inProgressIconAriaLabel',
    defaultMessage: 'In progress',
    description: 'Aria Label for the in progress icon on a notification',
  },
});

export default gandalfFlashbarMessages;
